var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipServiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.375 0.375 23.25 23.25",
    strokeWidth: 0.75,
    height: 500,
    width: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.75 23.25a5.75 5.75 0 0 0 4.5-2c1.5 1.5 1.75 2 3.25 2s2-.5 3.5-2c1.5 1.5 2 2 3.5 2s1.75-.5 3.25-2a5.75 5.75 0 0 0 4.5 2",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.88 20.2.26-2.11a.71.71 0 0 0-.14-.59.73.73 0 0 0-.56-.25H1.5a.76.76 0 0 0-.55.24.74.74 0 0 0-.2.58 8.2 8.2 0 0 0 .54 2.26",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 17.25h-6v-12a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Z",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.75 7.25-3 0",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 3.75 0-3",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.75h12l0 0v8.5l0 0H2.25l0 0v-7a1.5 1.5 0 0 1 1.5-1.5Z",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.25 8.75 0 8.5",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.25 13 13.24 0",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipServiceIcon);
export default __webpack_public_path__ + "static/media/ship-service-icon.148f8396961d63b0c3338e38a0190b18.svg";
export { ForwardRef as ReactComponent };